import { Routes } from '@angular/router';

import { HomeComponent } from './public/components/home.component';
import { BalajiSevasamithiComponent } from './public/components/balaji-sevasamithi.component';
import { OurCollegesComponent } from './public/components/our-colleges.component';
import { ManagementComponent } from './public/components/management.component';
import { FaqsComponent } from './public/components/faqs.component';
import { SriBalajiEducationalSocietyComponent } from './public/components/sri-balaji-educational-society.component';
import { AboutComponent } from './public/components/about.component';
import { GalleryComponent } from './public/components/gallery.component';
import { ContactComponent } from './public/components/contact.component';
import { FounderComponent } from './public/components/founder.component';
import { ChairmanComponent } from './public/components/chairman.component';
import { DirectorComponent } from './public/components/director.component';
import { SpecialOfficerComponent } from './public/components/specialofficer.component';
import { RepresentativeComponent } from './public/components/representative.component';



export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  /*about*/
  {
    path: 'about',
    component: AboutComponent,
    children: [
      { path: '', redirectTo: 'sri-balaji-educational-society', pathMatch: 'full' },
      { path: 'sri-balaji-educational-society', component: SriBalajiEducationalSocietyComponent },      
      { path: 'founder', component: FounderComponent },
      { path: 'chairman', component: ChairmanComponent },
      { path: 'management', component: ManagementComponent },
      { path: 'treasurer', component: DirectorComponent },
      { path: 'director', component: DirectorComponent },
      { path: 'faqs', component: FaqsComponent },
      { path: 'special-officer', component: SpecialOfficerComponent },
      { path: 'representative', component: RepresentativeComponent }
    ]
  },
  { path: 'balaji-sevasamithi', component: BalajiSevasamithiComponent },
  { path: 'our-colleges', component: OurCollegesComponent },
  /* GALLERY & CONTACT */
  { path: 'gallery', component: GalleryComponent },
  { path: 'contact', component: ContactComponent },
];
